import { InfoItem } from './InfoItem'
import { FC } from 'react'
import { Loader } from '../../Loader'
import { useDispatch } from 'react-redux'
import { Button, cn } from '@wellesley/ui'
import { authSlice } from '../../../authSlice'
import { useGetApiV1RulesQuery } from '../../../authApi'
import { SignUpStages } from '../SignUpStages'
import { useScrollActivity } from 'hooks/useScrollActivity'

export const PlatformRules: FC = () => {
  const { data: rules, isLoading: isRulesLoading } = useGetApiV1RulesQuery()
  const { isScrolledAllView, hasScroll, ref } = useScrollActivity()

  const dispatch = useDispatch()

  const handleAccept = () => {
    dispatch(authSlice.actions.setSignupStep('signup'))
  }

  if (isRulesLoading) return <Loader />
  if (!rules) return null

  const sortedRules = [...rules].sort((a, b) => a.ordering - b.ordering)
  return (
    <div className="flex h-full min-h-0  flex-col">
      <SignUpStages position={1} />
      <div
        ref={ref}
        className={cn('min-h-0 w-full flex-1 overflow-y-auto', {
          'border-y border-y-gray-200': hasScroll,
        })}
      >
        <div className="mx-auto grid w-[450px] gap-s py-m">
          {sortedRules?.map(({ id, hint, text }, index) => (
            <InfoItem
              key={id}
              counter={index + 1}
              title={text}
              description={hint}
            />
          ))}
        </div>
      </div>
      <div className="flex w-full justify-end p-m">
        <Button
          disabled={!isScrolledAllView}
          size="m"
          variant="primary"
          onClick={handleAccept}
        >
          Agree
        </Button>
      </div>
    </div>
  )
}
